//
// Copyright 2024 DXOS.org
//
export var ProfileArchiveEntryType;
(function (ProfileArchiveEntryType) {
    ProfileArchiveEntryType[ProfileArchiveEntryType["FILE"] = 1] = "FILE";
    ProfileArchiveEntryType[ProfileArchiveEntryType["KEY_VALUE"] = 2] = "KEY_VALUE";
    /** OPFS-hosted SQLite database; `key` is the OPFS filename, `value` is raw SQLite bytes. */
    ProfileArchiveEntryType[ProfileArchiveEntryType["SQLITE_DATABASE"] = 3] = "SQLITE_DATABASE";
})(ProfileArchiveEntryType || (ProfileArchiveEntryType = {}));
//# sourceMappingURL=profile-archive.js.map